/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as global from "../../../js/global";
import * as helper from "../../../js/helper";
import full_loading from "../../components/full-loading.vue";
import Datepicker from "../../../js/vuejs-datepicker.min.js";
import search_filters_modal from "../../modal/search-filters-modal.vue";
import filter_tablets_component from "../../components/filter-tablets-component.vue";
const __vue_script__ = {
  components: {
    full_loading: full_loading,
    Datepicker: Datepicker,
    search_filters_modal: search_filters_modal,
    filter_tablets_component: filter_tablets_component,
  },
  name: "deals-list",
  props: {},
  data() {
    return {
      global,
      helper,
      frappe,
      search_filters: localStorage.my_deals_search_filters
        ? JSON.parse(localStorage.my_deals_search_filters)
        : global.search_filters,
      is_ready: false,
      is_loading: false,
      deals: [],
      agencies: [],
      members: [],
      selected_deal: null,
      reason: null,
      ended_at: null,
      page: 0,
      end_of_page: false,
      sort_by: "creation",
      order: "DESC",
    };
  },
  async mounted() {
    if(this.search_filters.selected_agency == undefined){
      this.search_filters.selected_agency = "";
    }
    if(this.search_filters.selected_member == undefined){
      this.search_filters.selected_member = "";
    }
    if(frappe.user_roles.includes('Agency')){
        await this.load_members();
    }else if(frappe.user_roles.includes('Member')){
        await this.load_agencies();
    }
    
    if(!frappe.user_roles.includes('Member')){
        this.search_filters.selected_agency = ""
        localStorage.dashboard_search_filters = JSON.stringify(
            this.search_filters
        );
    }
    if(!frappe.user_roles.includes('Agency')){
        this.search_filters.selected_member = ""
        localStorage.dashboard_search_filters = JSON.stringify(
            this.search_filters
        );
    }
    
    global.emitter.on("load-search-again", (args) => {
      this.load_data(true);
    });
    if (!helper.isPageNew()) {
      this.check_local_storage();
    } else {
      this.load_data(true);
    }
    
    window.addEventListener("scroll", this.handleScroll);
  },
  unmounted() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    check_local_storage: async function () {
      this.page = (await localStorage.my_deals_page)
        ? localStorage.my_deals_page
        : 0;
      this.end_of_page = localStorage.my_deals_end_of_page == 1 ? true : false;
      this.deals = localStorage.my_deals_records
        ? JSON.parse(localStorage.my_deals_records)
        : [];
      for (let index = 0; index < this.deals.length; index++) {
        this.deals[index]["next"] = helper.toMomentObj(
          this.deals[index]["next"]
        );
        this.deals[index]["start"] = helper.toMomentObj(
          this.deals[index]["start"]
        );
        this.deals[index]["end"] = helper.toMomentObj(
          this.deals[index]["end"]
        );
      }
      this.$forceUpdate();
    },
    reset: function () {
      this.selected_deal = null;
      this.reason = null;
    },
    load_agencies: async function(reload=true){
        if(reload){
            while(this.agencies.length > 0) {
            this.agencies.pop();
            }
        }
        let params = {};
        let url = "/api/method/maalek.api.get_registered_agencies";
        let res = await $.ajax({
            url: url,
            type: "GET",
            data: params
        });
        for (let index = 0; index < res.message.length; index++) {
            this.agencies.push(res.message[index]);
        }
        if(this.search_filters.selected_agency.length > 0){
            if(this.agencies.find((agency)=>agency.agency == this.search_filters.selected_agency) == undefined){
                this.search_filters.selected_agency = ""
                localStorage.dashboard_search_filters = JSON.stringify(
                    this.search_filters
                );
            }
        }
    },
    load_members: async function(reload=true){
        if(reload){
            while(this.agencies.length > 0) {
                this.agencies.pop();
            }
        }
        let params = {};
        let url = "/api/method/maalek.api.get_agency_members";
        let res = await $.ajax({
            url: url,
            type: "GET",
            data: params
        });
        for (let index = 0; index < res.message.length; index++) {
            this.members.push(res.message[index]);
        }
        if(this.search_filters.selected_member.length > 0){
            if(this.members.find((member)=>member.member == this.search_filters.selected_member) == undefined){
                this.search_filters.selected_member = ""
                localStorage.dashboard_search_filters = JSON.stringify(
                    this.search_filters
                );
            }
        }
    },
    load_data: async function (reload = false) {
        if (this.is_loading) return;
        if (reload) {
            this.page = 0;
            this.end_of_page = false;
            while (this.deals.length > 0) {
            this.deals.pop();
            }
        }
        if (this.end_of_page) return;
        global.emitter.emit("show-full-loading");
        this.is_loading = true;
        
        let params = {
            filters: JSON.stringify(this.search_filters),
            page: this.page,
        };
        let url = "/api/method/maalek.api.get_my_deals";
        let res = await $.ajax({
            url: url,
            type: "GET",
            data: params,
        });

        if (res.message.length > 0) {
            for (let index = 0; index < res.message.length; index++) {
            res.message[index]["creation"] = new Date(
                res.message[index]["creation"]
            );
            res.message[index]["start"] = helper.toMomentObj(
                res.message[index]["start"]
            );
            res.message[index]["end"] = helper.toMomentObj(
                res.message[index]["end"]
            );
            res.message[index]["next"] = helper.toMomentObj(
                res.message[index]["next"]
            );
            if(res.message[index]["ended_at"]){
              res.message[index]["ended_at"] = helper.toMomentObj(
                  res.message[index]["ended_at"]
              );
            }
            res.message[index]["expanded"] = false;
            this.deals.push(res.message[index]);
            }
            this.page++;
        } else {
            this.end_of_page = 1;
        }

        localStorage.my_deals_records = JSON.stringify(this.deals);
        localStorage.my_deals_search_filters = JSON.stringify(
            this.search_filters
        );
        localStorage.my_deals_page = this.page;
        localStorage.my_deals_end_of_page = this.end_of_page ? 1 : 0;
        this.is_ready = true;
        this.is_loading = false;
        global.emitter.emit("hide-full-loading");
    },
    close_deal: async function () {
      try {
        global.emitter.emit("show-full-loading");
        let params = {
          deal_name: this.selected_deal["deal_name"],
          reason: this.reason,
          ended_at: this.ended_at,
        };

        let res = await $.ajax({
          headers: { "X-Frappe-CSRF-Token": frappe.csrf_token },
          url: "/api/method/maalek.api.close_deal",
          type: "POST",
          // data: params //for GET request
          data: JSON.stringify(params), //for POST request
        });
        global.emitter.emit("hide-full-loading");
        helper.showSuccess("Deal " + this.reason + " Successfully", () => {
          location.reload();
        });
      } catch (e) {
        console.log(e);
        global.emitter.emit("hide-full-loading");
        var exceptions = helper.showException(e);
      }
    },
    openModal: function (elementID) {
      $(elementID).modal("show");
    },
    closeModal: function (elementID) {
      $(elementID).modal("hide");
    },
    handleScroll: function () {
      if (this.end_of_page) {
        window.removeEventListener("scroll", this.handleScroll);
      }
      if (this.loading || this.end_of_page) return;
      let pagination_component = this.$refs["pagination_component"];
      if (
        pagination_component.getBoundingClientRect().bottom < window.innerHeight
      ) {
        this.load_data();
      }
    },
    confirm_renew_deal: function(){
        bootbox.confirm({
                message: `<div class="alert alert-info" role="alert">
                    `+helper.t("Do you realy want to renew this deal?")+`
                </div>`,
                backdrop: true,
                callback: (results) => results?this.renew_deal():console.log("cancel"),
            });
    },
    renew_deal: async function(){
      try {
        global.emitter.emit("show-full-loading");
        let params = {
                      'deal_name': this.selected_deal["deal_name"],
                  };
        let res = await $.ajax({
          headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },
          url: "/api/method/maalek.api.renew_deal",
          type: "POST",
          // data: params //for GET request
          data: JSON.stringify(params) //for POST request
        });
        global.emitter.emit("hide-full-loading");
                  helper.showSuccess("Deal renewed successfully.",()=>{
          location.reload();
        });
      } catch (e) {
        global.emitter.emit("hide-full-loading");
        var exceptions = helper.showException(e);
      }
    },
  },
  computed: {},
};

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "pagination_component" },
    [
      _c("full_loading"),
      _vm._v(" "),
      [
        _c(
          "div",
          { staticClass: "d-flex justify-content-end mb-4" },
          [
            _c("filter_tablets_component", {
              attrs: { search_filters_prop: _vm.search_filters }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "btn-toolbar",
                attrs: {
                  role: "toolbar",
                  "aria-label": "Toolbar with button groups"
                }
              },
              [
                this.agencies.length > 0
                  ? _c(
                      "div",
                      {
                        staticClass: "btn-group me-2",
                        attrs: { role: "group" }
                      },
                      [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { staticClass: "filter-label" }, [
                            _vm._v(_vm._s(_vm.helper.t("Deals by")))
                          ]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.search_filters.selected_agency,
                                  expression: "search_filters.selected_agency"
                                }
                              ],
                              staticClass: "form-select",
                              attrs: { "aria-label": "Default select example" },
                              on: {
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.search_filters,
                                      "selected_agency",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                  function($event) {
                                    return _vm.load_data(true)
                                  }
                                ]
                              }
                            },
                            [
                              _c(
                                "option",
                                { attrs: { value: "", selected: "" } },
                                [_vm._v(_vm._s(_vm.helper.t("Private Deals")))]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.agencies, function(agency) {
                                return _c(
                                  "option",
                                  { domProps: { value: agency["agency"] } },
                                  [_vm._v(_vm._s(agency["full_name"]))]
                                )
                              })
                            ],
                            2
                          )
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                this.members.length > 0
                  ? _c(
                      "div",
                      {
                        staticClass: "btn-group me-2",
                        attrs: { role: "group" }
                      },
                      [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { staticClass: "filter-label" }, [
                            _vm._v(_vm._s(_vm.helper.t("Deals managed by")))
                          ]),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.search_filters.selected_member,
                                  expression: "search_filters.selected_member"
                                }
                              ],
                              staticClass: "form-select",
                              attrs: { "aria-label": "Default select example" },
                              on: {
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.search_filters,
                                      "selected_member",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                  function($event) {
                                    return _vm.load_data(true)
                                  }
                                ]
                              }
                            },
                            [
                              _c(
                                "option",
                                { attrs: { value: "", selected: "" } },
                                [_vm._v(_vm._s(_vm.helper.t("All")))]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.members, function(member) {
                                return _c(
                                  "option",
                                  { domProps: { value: member["member"] } },
                                  [_vm._v(_vm._s(member["full_name"]))]
                                )
                              })
                            ],
                            2
                          )
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "btn-group me-2", attrs: { role: "group" } },
                  [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { staticClass: "filter-label" }, [
                        _vm._v(_vm._s(_vm.helper.t("Sort by")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.search_filters.sort_by,
                              expression: "search_filters.sort_by"
                            }
                          ],
                          staticClass: "form-select",
                          attrs: { "aria-label": "Default select example" },
                          on: {
                            change: [
                              function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.search_filters,
                                  "sort_by",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                              function($event) {
                                return _vm.load_data(true)
                              }
                            ]
                          }
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v(_vm._s(_vm.helper.t("Sort by")))
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "Latest" } }, [
                            _vm._v(_vm._s(_vm.helper.t("Latest")))
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "Oldest" } }, [
                            _vm._v(_vm._s(_vm.helper.t("Oldest")))
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "Upcoming" } }, [
                            _vm._v(_vm._s(_vm.helper.t("Upcoming Rent")))
                          ])
                        ]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "btn-group me-2", attrs: { role: "group" } },
                  [
                    _c("label", { staticClass: "filter-label" }, [
                      _vm._v(_vm._s(_vm.helper.t("Status")))
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn",
                        class:
                          _vm.search_filters.status == null
                            ? "btn-primary"
                            : "btn-outline-secondary",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            _vm.search_filters.status = null
                            _vm.load_data(true)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.helper.t("All")) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn",
                        class:
                          _vm.search_filters.status == "Active"
                            ? "btn-primary"
                            : "btn-outline-secondary",
                        attrs: {
                          type: "button",
                          "data-bs-toggle": "tooltip",
                          "data-bs-placement": "top",
                          title: _vm.helper.t("Active"),
                          "data-bs-trigger": "hover"
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            _vm.search_filters.status = "Active"
                            _vm.load_data(true)
                          }
                        }
                      },
                      [_c("i", { staticClass: "fa-solid fa-handshake" })]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn",
                        class:
                          _vm.search_filters.status == "Ended"
                            ? "btn-primary"
                            : "btn-outline-secondary",
                        attrs: {
                          type: "button",
                          "data-bs-toggle": "tooltip",
                          "data-bs-placement": "top",
                          title: _vm.helper.t("Ended / Closed"),
                          "data-bs-trigger": "hover"
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            _vm.search_filters.status = "Ended"
                            _vm.load_data(true)
                          }
                        }
                      },
                      [_c("i", { staticClass: "fa-solid fa-handshake-slash" })]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "btn-group",
                    attrs: { role: "group", "aria-label": "Third group" }
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-secondary",
                        attrs: {
                          type: "button",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#searchFiltersModal"
                        }
                      },
                      [
                        _c("i", { staticClass: "fa-solid fa-sliders" }),
                        _vm._v(
                          " " +
                            _vm._s(_vm.helper.t("More Filters")) +
                            "\n          "
                        )
                      ]
                    )
                  ]
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        !_vm.is_loading && _vm.is_ready && _vm.deals.length == 0
          ? _c("h5", { staticClass: "text-center" }, [
              _vm._v(
                "\n      " + _vm._s(_vm.helper.t("No deal found!")) + "\n    "
              )
            ])
          : _c("table", { staticClass: "table align-middle" }, [
              _c("thead", [
                _c("tr", [
                  _c("th", { attrs: { scope: "col" } }, [
                    _vm._v(_vm._s(_vm.helper.t("Deal#")))
                  ]),
                  _vm._v(" "),
                  _c("th", { attrs: { scope: "col" } }, [
                    _vm._v(_vm._s(_vm.helper.t("Property")))
                  ]),
                  _vm._v(" "),
                  _c("th", { attrs: { scope: "col" } }, [
                    _vm._v(_vm._s(_vm.helper.t("Name")))
                  ]),
                  _vm._v(" "),
                  _vm.flase
                    ? _c("th", { attrs: { scope: "col" } }, [
                        _vm._v(_vm._s(_vm.helper.t("Contact#")))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("th", { attrs: { scope: "col" } }, [
                    _vm._v(_vm._s(_vm.helper.t("Type")))
                  ]),
                  _vm._v(" "),
                  _c("th", { attrs: { scope: "col" } }, [
                    _vm._v(_vm._s(_vm.helper.t("Next Rent")))
                  ]),
                  _vm._v(" "),
                  _c("th", { attrs: { scope: "col" } }, [
                    _vm._v(_vm._s(_vm.helper.t("Status")))
                  ]),
                  _vm._v(" "),
                  _c("th", { attrs: { scope: "col" } })
                ])
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  _vm._l(_vm.deals, function(deal) {
                    return [
                      _c(
                        "tr",
                        {
                          class: deal["expanded"] ? "table-active" : "",
                          attrs: { role: "button" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              deal["expanded"] = !deal["expanded"]
                            }
                          }
                        },
                        [
                          _c("td", {}, [
                            _c("i", {
                              staticClass: "fa-solid",
                              class: deal["expanded"]
                                ? "fa-caret-up"
                                : "fa-caret-down"
                            }),
                            _vm._v(
                              "\n              " +
                                _vm._s(deal["deal_name"]) +
                                "\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", {}, [_vm._v(_vm._s(deal["property"]))]),
                          _vm._v(" "),
                          _c("td", {}, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.helper.truncateString(
                                    deal["deal_to_full_name"],
                                    12
                                  )
                                ) +
                                "\n            "
                            )
                          ]),
                          _vm._v(" "),
                          _vm.flase
                            ? _c(
                                "td",
                                { attrs: { scope: "row" } },
                                [
                                  deal["deal_to"]
                                    ? [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              deal["deal_to"].toString()
                                                ? "0" +
                                                    deal["deal_to"].substring(4)
                                                : ""
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    : _vm._e()
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("td", {}, [
                            _vm._v(_vm._s(_vm.helper.t(deal["ad_type"])))
                          ]),
                          _vm._v(" "),
                          deal["ad_type"] == "Rent" && !deal["ended"]
                            ? _c("td", {}, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.helper.toMomentStringTranslationFromNow(
                                        deal["next"].fromNow()
                                      )
                                    ) +
                                    "\n            "
                                )
                              ])
                            : _c("td", {}, [_vm._v("-")]),
                          _vm._v(" "),
                          deal["ad_type"] == "Rent"
                            ? _c("td", {}, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.helper.t(
                                        deal["ended"] ||
                                          deal["reason"] == "Expired"
                                          ? deal["reason"]
                                          : "Active"
                                      )
                                    ) +
                                    "\n              "
                                ),
                                deal["ended"]
                                  ? _c("small", { attrs: { dir: "ltr" } }, [
                                      _vm._v(
                                        "(" +
                                          _vm._s(
                                            deal["ended_at"].format(
                                              "DD-MMM-YYYY"
                                            )
                                          ) +
                                          ")"
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            : _c("td", {}, [_vm._v("-")]),
                          _vm._v(" "),
                          !deal["ended"] && deal["ad_type"] == "Rent"
                            ? _c("td", {}, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "btn-group",
                                    attrs: {
                                      role: "group",
                                      "aria-label": "Basic example"
                                    }
                                  },
                                  [
                                    !deal["ended"] &&
                                    deal["reason"] == "Expired"
                                      ? _c(
                                          "button",
                                          {
                                            staticClass: "btn btn-primary",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                _vm.reset()
                                                _vm.selected_deal = deal
                                                _vm.confirm_renew_deal()
                                              }
                                            }
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "fa-solid fa-arrow-rotate-left"
                                            })
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-primary",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            _vm.reset()
                                            _vm.selected_deal = deal
                                            _vm.openModal("#end-deal-modal")
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa-solid fa-handshake-slash"
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ])
                            : _c("td", {})
                        ]
                      ),
                      _vm._v(" "),
                      deal["expanded"]
                        ? _c("tr", { staticClass: "table-info" }, [
                            _c("td", { attrs: { colspan: "8" } }, [
                              _c(
                                "div",
                                {
                                  staticClass: "d-flex justify-content-between"
                                },
                                [
                                  _c("h6", { staticClass: "m-0" }, [
                                    _vm._v(_vm._s(_vm.helper.t("Deal Details")))
                                  ]),
                                  _vm._v(" "),
                                  _vm.frappe.user_roles.includes("Agency")
                                    ? [
                                        deal["member_full_name"]
                                          ? _c(
                                              "h6",
                                              {
                                                staticClass: "m-0",
                                                attrs: {
                                                  "data-bs-toggle": "tooltip",
                                                  "data-bs-placement": "top",
                                                  title: _vm.helper.t(
                                                    "Dealt By"
                                                  )
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      deal.member_full_name
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          : _c(
                                              "h6",
                                              {
                                                staticClass: "m-0",
                                                attrs: {
                                                  "data-bs-toggle": "tooltip",
                                                  "data-bs-placement": "top",
                                                  title: _vm.helper.t(
                                                    "Dealt By"
                                                  )
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.helper.t(
                                                        "Dealt By: {0}",
                                                        [
                                                          _vm.frappe
                                                            .session_user_full_name
                                                        ]
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                      ]
                                    : _vm._e()
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("hr", { staticClass: "m-0" }),
                              _vm._v(" "),
                              _c(
                                "table",
                                { staticClass: "table table-borderless" },
                                [
                                  _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        staticClass:
                                          "d-flex justify-content-start"
                                      },
                                      [
                                        _c("div", [
                                          _vm._v(_vm._s(_vm.helper.t("Date:")))
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { attrs: { dir: "ltr" } }, [
                                          _c("b", [
                                            _vm._v(
                                              _vm._s(
                                                deal["creation"].getDate() +
                                                  "-" +
                                                  _vm.global.global_params
                                                    .months[
                                                    deal["creation"].getMonth()
                                                  ] +
                                                  "-" +
                                                  deal["creation"].getFullYear()
                                              )
                                            )
                                          ])
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      [
                                        deal["deal_to"]
                                          ? [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.helper.t("Contact:")
                                                  ) +
                                                  "\n                      "
                                              ),
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    deal["deal_to"].toString()
                                                      ? "0" +
                                                          deal[
                                                            "deal_to"
                                                          ].substring(4)
                                                      : ""
                                                  )
                                                )
                                              ])
                                            ]
                                          : _vm._e()
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      [
                                        deal["deal_to_full_name"]
                                          ? [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.helper.t("Full Name")
                                                  ) +
                                                  ":\n                      "
                                              ),
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(
                                                    deal["deal_to_full_name"]
                                                  )
                                                )
                                              ])
                                            ]
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("tr", [
                                    _c("td", [
                                      _c("div", [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.helper.t("Deal Price:")
                                            ) +
                                            " "
                                        ),
                                        _c("b", [_vm._v(_vm._s(deal["price"]))])
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.helper.t("Through Maalek")
                                          ) +
                                          ":\n                    "
                                      ),
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            deal["using_maalek"]
                                              ? _vm.helper.t("Yes")
                                              : _vm.helper.t("No")
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    deal["ad_type"] == "Rent"
                                      ? _c("td", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.helper.t("Rent Type:")
                                              ) +
                                              "\n                    "
                                          ),
                                          _c("b", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.helper.t(
                                                  deal["deal_rent_type"]
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    deal["ad_type"] == "Rent" &&
                                    deal["document"]
                                      ? _c("td", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.helper.t("Contract:")
                                              ) +
                                              "\n                    "
                                          ),
                                          _c(
                                            "a",
                                            {
                                              staticClass: "btn",
                                              attrs: {
                                                href:
                                                  "/api/method/maalek.api.download_contract_file?deal_name=" +
                                                  deal["deal_name"]
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fa-solid fa-lg fa-file-contract"
                                              })
                                            ]
                                          )
                                        ])
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  deal["ad_type"] == "Rent" && !deal["ended"]
                                    ? _c("tr", [
                                        _c("td", [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex justify-content-start"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "pe-2" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.helper.t("Start Date")
                                                    ) + ":"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { attrs: { dir: "ltr" } },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        deal["start"].format(
                                                          "DD-MMM-YYYY"
                                                        )
                                                      )
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex justify-content-start"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "pe-2" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.helper.t(
                                                        "Contract Ending At:"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { attrs: { dir: "ltr" } },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        deal["end"].format(
                                                          "DD-MMM-YYYY"
                                                        )
                                                      )
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex justify-content-start"
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "pe-2" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.helper.t("Next Rent")
                                                    ) + ":"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { attrs: { dir: "ltr" } },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        deal["next"].format(
                                                          "DD-MMM-YYYY"
                                                        )
                                                      )
                                                    )
                                                  ])
                                                ]
                                              )
                                            ]
                                          )
                                        ])
                                      ])
                                    : _vm._e()
                                ]
                              )
                            ])
                          ])
                        : _vm._e()
                    ]
                  })
                ],
                2
              )
            ]),
        _vm._v(" "),
        _c("search_filters_modal", {
          attrs: {
            for_map_search: false,
            search_filters_prop: _vm.search_filters
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "modal fade filter-popup-area",
            attrs: {
              id: "end-deal-modal",
              "data-bs-keyboard": "false",
              tabindex: "-1",
              "aria-labelledby": "staticBackdropLabel",
              "aria-hidden": "true"
            }
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "modal-dialog modal-dialog-centered modal-dialog-scrollable"
              },
              [
                _vm.selected_deal
                  ? _c(
                      "div",
                      { staticClass: "modal-content overflow-visible" },
                      [
                        _c("div", { staticClass: "modal-header" }, [
                          _c(
                            "h5",
                            {
                              staticClass: "modal-title",
                              attrs: { id: "staticBackdropLabel" }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.helper.t("Close Deal: {0}", [
                                      _vm.selected_deal["deal_name"]
                                    ])
                                  ) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("button", {
                            staticClass: "btn-close",
                            attrs: {
                              type: "button",
                              "data-bs-dismiss": "modal",
                              "aria-label": "Close"
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "modal-body overflow-visible" },
                          [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col" }, [
                                _c("div", { staticClass: "form-group mb-4" }, [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "toggler",
                                      attrs: { id: "filt-yearly" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.helper.t(
                                            "Select reason of deal closure"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "btn-toolbar",
                                      attrs: {
                                        role: "toolbar",
                                        "aria-label":
                                          "Toolbar with button groups"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "btn-group me-2",
                                          attrs: { role: "group" }
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass: "btn",
                                              class:
                                                _vm.reason == "Ended"
                                                  ? "btn-primary"
                                                  : "btn-outline-secondary",
                                              attrs: { type: "button" },
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  _vm.reason = "Ended"
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.helper.t("Deal Ended")
                                                  ) +
                                                  "\n                      "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              staticClass: "btn",
                                              class:
                                                _vm.reason == "Canceled"
                                                  ? "btn-primary"
                                                  : "btn-outline-secondary",
                                              attrs: { type: "button" },
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  _vm.reason = "Canceled"
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.helper.t(
                                                      "Deal Canceled"
                                                    )
                                                  ) +
                                                  "\n                      "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              staticClass: "btn",
                                              class:
                                                _vm.reason == "Terminated"
                                                  ? "btn-primary"
                                                  : "btn-outline-secondary",
                                              attrs: { type: "button" },
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  _vm.reason = "Terminated"
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.helper.t(
                                                      "Deal Terminated"
                                                    )
                                                  ) +
                                                  "\n                      "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.reason
                                  ? _c("div", { staticClass: "col-4 mb-4" }, [
                                      _c(
                                        "div",
                                        { staticClass: "form-group" },
                                        [
                                          _c("label", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.helper.t("Deal {0} at?", [
                                                  _vm.helper.t(_vm.reason)
                                                ])
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("Datepicker", {
                                            attrs: {
                                              dir: "ltr",
                                              "input-class":
                                                "form-control border-radius text-start"
                                            },
                                            model: {
                                              value: _vm.ended_at,
                                              callback: function($$v) {
                                                _vm.ended_at = $$v
                                              },
                                              expression: "ended_at"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                { staticClass: "col show-hand text-end" },
                                [
                                  _vm.reason && _vm.ended_at
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "btn default-btn mt-2",
                                          on: {
                                            click: function($event) {
                                              return _vm.close_deal()
                                            }
                                          }
                                        },
                                        [
                                          _c("p", [
                                            _vm._v(_vm._s(_vm.helper.t("Save")))
                                          ])
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "btn default-btn show-hand mt-2",
                                      on: {
                                        click: function($event) {
                                          return _vm.closeModal(
                                            "#end-deal-modal"
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("p", [
                                        _vm._v(_vm._s(_vm.helper.t("No wait!")))
                                      ])
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              ]
            )
          ]
        )
      ]
    ],
    2
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-6ea02c3d_0", { source: "\n.filter-label{\n  top: -20px;\n  position: absolute;\n}\n", map: {"version":3,"sources":["../maalek/maalek/public/vue/widgets/account/deals-list.vue"],"names":[],"mappings":";AA0sBA;EACA,UAAA;EACA,kBAAA;AACA","file":"deals-list.vue","sourcesContent":["<template>\n  <div ref=\"pagination_component\">\n    <full_loading></full_loading>\n    <template>\n      <div class=\"d-flex justify-content-end mb-4\">\n        <filter_tablets_component :search_filters_prop=\"search_filters\">\n        </filter_tablets_component>\n        <div\n          class=\"btn-toolbar\"\n          role=\"toolbar\"\n          aria-label=\"Toolbar with button groups\"\n        >\n          <div v-if=\"this.agencies.length > 0\" class=\"btn-group me-2\" role=\"group\">\n            <div class=\"form-group\">\n              <label class=\"filter-label\">{{ helper.t(\"Deals by\") }}</label>\n              <select v-model=\"search_filters.selected_agency\" @change=\"load_data(true)\" class=\"form-select\" aria-label=\"Default select example\">\n                <option value=\"\" selected>{{ helper.t(\"Private Deals\") }}</option> \n                <option v-for=\"agency in agencies\" :value=\"agency['agency']\">{{ agency['full_name'] }}</option>\n              </select>\n            </div>\n          </div>\n          <div v-if=\"this.members.length > 0\" class=\"btn-group me-2\" role=\"group\">\n            <div class=\"form-group\">\n              <label class=\"filter-label\">{{ helper.t(\"Deals managed by\") }}</label>\n              <select v-model=\"search_filters.selected_member\" @change=\"load_data(true)\" class=\"form-select\" aria-label=\"Default select example\">\n                <option value=\"\" selected>{{ helper.t(\"All\") }}</option> \n                <option v-for=\"member in members\" :value=\"member['member']\">{{ member['full_name'] }}</option>\n              </select>\n            </div>\n          </div>\n          <div class=\"btn-group me-2\" role=\"group\">\n            <div class=\"form-group\">\n              <label class=\"filter-label\">{{ helper.t(\"Sort by\") }}</label>\n              <select v-model=\"search_filters.sort_by\" @change=\"load_data(true)\" class=\"form-select\" aria-label=\"Default select example\">\n                <option value=\"\">{{ helper.t(\"Sort by\") }}</option>\n                <option value=\"Latest\">{{ helper.t(\"Latest\") }}</option>\n                <option value=\"Oldest\">{{ helper.t(\"Oldest\") }}</option>\n                <option value=\"Upcoming\">{{ helper.t(\"Upcoming Rent\") }}</option>\n              </select>\n            </div>\n          </div>\n          <div class=\"btn-group me-2\" role=\"group\">\n            <label class=\"filter-label\">{{ helper.t(\"Status\") }}</label>\n            <button\n              type=\"button\"\n              class=\"btn\"\n              @click.prevent=\"\n                search_filters.status = null;\n                load_data(true);\n              \"\n              :class=\"\n                search_filters.status == null\n                  ? 'btn-primary'\n                  : 'btn-outline-secondary'\n              \"\n            >\n              {{ helper.t(\"All\") }}\n            </button>\n            <button\n              type=\"button\"\n              class=\"btn\"\n              data-bs-toggle=\"tooltip\"\n              data-bs-placement=\"top\"\n              :title=\"helper.t('Active')\"\n              data-bs-trigger=\"hover\"\n              @click.prevent=\"\n                search_filters.status = 'Active';\n                load_data(true);\n              \"\n              :class=\"\n                search_filters.status == 'Active'\n                  ? 'btn-primary'\n                  : 'btn-outline-secondary'\n              \"\n            >\n              <i class=\"fa-solid fa-handshake\"></i>\n            </button>\n            <button\n              type=\"button\"\n              class=\"btn\"\n              data-bs-toggle=\"tooltip\"\n              data-bs-placement=\"top\"\n              :title=\"helper.t('Ended / Closed')\"\n              data-bs-trigger=\"hover\"\n              @click.prevent=\"\n                search_filters.status = 'Ended';\n                load_data(true);\n              \"\n              :class=\"\n                search_filters.status == 'Ended'\n                  ? 'btn-primary'\n                  : 'btn-outline-secondary'\n              \"\n            >\n              <i class=\"fa-solid fa-handshake-slash\"></i>\n            </button>\n          </div>\n          <div class=\"btn-group\" role=\"group\" aria-label=\"Third group\">\n            <button\n              type=\"button\"\n              class=\"btn btn-outline-secondary\"\n              data-bs-toggle=\"modal\"\n              data-bs-target=\"#searchFiltersModal\"\n            >\n              <i class=\"fa-solid fa-sliders\"></i> {{ helper.t(\"More Filters\") }}\n            </button>\n          </div>\n        </div>\n      </div>\n      <h5 v-if=\"!is_loading && is_ready && deals.length == 0\" class=\"text-center\">\n        {{ helper.t(\"No deal found!\") }}\n      </h5>\n      <table v-else class=\"table align-middle\">\n        <thead>\n          <tr>\n            <th scope=\"col\">{{ helper.t(\"Deal#\") }}</th>\n            <th scope=\"col\">{{ helper.t(\"Property\") }}</th>\n            <th scope=\"col\">{{ helper.t(\"Name\") }}</th>\n            <th v-if=\"flase\" scope=\"col\">{{ helper.t(\"Contact#\") }}</th>\n            <th scope=\"col\">{{ helper.t(\"Type\") }}</th>\n            <th scope=\"col\">{{ helper.t(\"Next Rent\") }}</th>\n            <th scope=\"col\">{{ helper.t(\"Status\") }}</th>\n            <th scope=\"col\"></th>\n          </tr>\n        </thead>\n        <tbody>\n          <template v-for=\"deal in deals\">\n            <tr\n              :class=\"deal['expanded'] ? 'table-active' : ''\"\n              @click.prevent=\"deal['expanded'] = !deal['expanded']\"\n              role=\"button\"\n            >\n              <td  class=\"\">\n                <i\n                  class=\"fa-solid\"\n                  :class=\"deal['expanded'] ? 'fa-caret-up' : 'fa-caret-down'\"\n                ></i>\n                {{ deal[\"deal_name\"] }}\n              </td>\n              <td class=\"\">{{ deal[\"property\"] }}</td>\n              <td class=\"\">\n                {{ helper.truncateString(deal[\"deal_to_full_name\"], 12) }}\n              </td>\n              <td v-if=\"flase\" class=\"\" scope=\"row\">\n                <template v-if=\"deal['deal_to']\">\n                  {{\n                    deal[\"deal_to\"].toString()\n                      ? \"0\" + deal[\"deal_to\"].substring(4)\n                      : \"\"\n                  }}\n                </template>\n              </td>\n              <td class=\"\">{{ helper.t(deal[\"ad_type\"]) }}</td>\n              <td v-if=\"deal['ad_type'] == 'Rent' && !deal['ended']\"\n                class=\"\">\n                {{\n                  helper.toMomentStringTranslationFromNow(\n                    deal[\"next\"].fromNow()\n                  )\n                }}\n              </td>\n              <td v-else class=\"\">-</td>\n              <td v-if=\"deal['ad_type'] == 'Rent'\"\n                class=\"\">\n                {{ helper.t(deal[\"ended\"] || deal[\"reason\"] == \"Expired\" ? deal[\"reason\"] : \"Active\") }}\n                <small dir=\"ltr\" v-if=\"deal['ended']\">({{ deal[\"ended_at\"].format(\"DD-MMM-YYYY\") }})</small>\n              </td>\n              <td v-else class=\"\">-</td>\n              <td v-if=\"!deal['ended'] && deal['ad_type'] == 'Rent'\"\n                class=\"\">\n                <div class=\"btn-group\" role=\"group\" aria-label=\"Basic example\">\n                  <button v-if='!deal[\"ended\"] && deal[\"reason\"] == \"Expired\"'\n                    type=\"button\"\n                    class=\"btn btn-primary\"\n                    @click.prevent=\"\n                      reset();\n                      selected_deal = deal;\n                      confirm_renew_deal();\n                    \"\n                  >\n                    <i class=\"fa-solid fa-arrow-rotate-left\"></i>\n                  </button>\n                  <button\n                    type=\"button\"\n                    class=\"btn btn-primary\"\n                    @click.prevent=\"\n                      reset();\n                      selected_deal = deal;\n                      openModal('#end-deal-modal');\n                    \"\n                  >\n                    <i class=\"fa-solid fa-handshake-slash\"></i>\n                  </button>\n                </div>\n              </td>\n              <td v-else class=\"\">\n              </td>\n            </tr>\n            <tr class=\"table-info\" v-if=\"deal['expanded']\">\n              <td colspan=\"8\">\n                <div class=\"d-flex justify-content-between\">\n                  <h6 class=\"m-0\">{{ helper.t(\"Deal Details\") }}</h6>\n                  <template v-if=\"frappe.user_roles.includes('Agency')\">\n                    <h6 class=\"m-0\" v-if=\"deal['member_full_name']\"  data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Dealt By')\">\n                      {{ deal.member_full_name }}\n                    </h6>\n                    <h6 class=\"m-0\" v-else data-bs-toggle=\"tooltip\" data-bs-placement=\"top\" :title=\"helper.t('Dealt By')\">\n                      {{ helper.t('Dealt By: {0}',[frappe.session_user_full_name]) }}\n                    </h6>\n                  </template>\n                </div>\n                <hr class=\"m-0\">\n                <table class=\"table table-borderless\">\n                  <tr>\n                    <td class=\"d-flex justify-content-start\">\n                      <div>{{ helper.t(\"Date:\") }}</div>\n                      <div dir=\"ltr\">\n                        <b>{{\n                          deal[\"creation\"].getDate() +\n                          \"-\" +\n                          global.global_params.months[\n                            deal[\"creation\"].getMonth()\n                          ] +\n                          \"-\" +\n                          deal[\"creation\"].getFullYear()\n                        }}</b>\n                      </div>\n                    </td>\n                    <td>\n                      <template v-if=\"deal['deal_to']\">\n                        {{ helper.t(\"Contact:\") }}\n                        <b>{{\n                          deal[\"deal_to\"].toString()\n                            ? \"0\" + deal[\"deal_to\"].substring(4)\n                            : \"\"\n                        }}</b>\n                      </template>\n                    </td>\n                    <td>\n                      <template v-if=\"deal['deal_to_full_name']\">\n                        {{ helper.t(\"Full Name\") }}:\n                        <b>{{ deal[\"deal_to_full_name\"] }}</b>\n                      </template>\n                    </td>\n                  </tr>\n                  <tr>\n                    <td>\n                      <div>\n                        {{ helper.t(\"Deal Price:\") }} <b>{{ deal[\"price\"] }}</b>\n                      </div>\n                    </td>\n                    <td>\n                      {{ helper.t(\"Through Maalek\") }}:\n                      <b>{{\n                        deal[\"using_maalek\"] ? helper.t(\"Yes\") : helper.t(\"No\")\n                      }}</b>\n                    </td>\n                    <td v-if=\"deal['ad_type'] == 'Rent'\">\n                      {{ helper.t(\"Rent Type:\") }}\n                      <b>{{ helper.t(deal[\"deal_rent_type\"]) }}</b>\n                    </td>\n                    <td v-if=\"deal['ad_type'] == 'Rent' && deal['document']\">\n                      {{ helper.t(\"Contract:\") }}\n                      <a class=\"btn\" :href=\"'/api/method/maalek.api.download_contract_file?deal_name='+deal['deal_name']\"><i class=\"fa-solid fa-lg fa-file-contract\"></i></a>\n                    </td>\n                  </tr>\n                  <tr v-if=\"deal['ad_type'] == 'Rent' && !deal['ended']\">\n                    <td>\n                      <div class=\"d-flex justify-content-start\">\n                        <div class=\"pe-2\">{{ helper.t(\"Start Date\") }}:</div>\n                        <div dir=\"ltr\">\n                          <b>{{ deal[\"start\"].format(\"DD-MMM-YYYY\") }}</b>\n                        </div>\n                      </div>\n                    </td>\n                    <td>\n                      <div class=\"d-flex justify-content-start\">\n                        <div class=\"pe-2\">{{ helper.t(\"Contract Ending At:\") }}</div>\n                        <div dir=\"ltr\">\n                          <b>{{ deal[\"end\"].format(\"DD-MMM-YYYY\") }}</b>\n                        </div>\n                      </div>\n                    </td>\n                    <td>\n                      <div class=\"d-flex justify-content-start\">\n                        <div class=\"pe-2\">{{ helper.t(\"Next Rent\") }}:</div>\n                        <div dir=\"ltr\">\n                          <b>{{ deal[\"next\"].format(\"DD-MMM-YYYY\") }}</b>\n                        </div>\n                      </div>\n                    </td>\n                  </tr>\n                </table>\n              </td>\n            </tr>\n          </template>\n        </tbody>\n      </table>\n      <!-- Modal -->\n      <search_filters_modal\n        :for_map_search=\"false\"\n        :search_filters_prop=\"search_filters\"\n      ></search_filters_modal>\n      <!-- Modal -->\n      <!-- Modal -->\n      <div\n        class=\"modal fade filter-popup-area\"\n        id=\"end-deal-modal\"\n        data-bs-keyboard=\"false\"\n        tabindex=\"-1\"\n        aria-labelledby=\"staticBackdropLabel\"\n        aria-hidden=\"true\"\n      >\n        <div class=\"modal-dialog modal-dialog-centered modal-dialog-scrollable\">\n          <div v-if=\"selected_deal\" class=\"modal-content overflow-visible\">\n            <div class=\"modal-header\">\n              <h5 class=\"modal-title\" id=\"staticBackdropLabel\">\n                {{ helper.t(\"Close Deal: {0}\", [selected_deal[\"deal_name\"]]) }}\n              </h5>\n              <button\n                type=\"button\"\n                class=\"btn-close\"\n                data-bs-dismiss=\"modal\"\n                aria-label=\"Close\"\n              ></button>\n            </div>\n            <div class=\"modal-body overflow-visible\">\n              <div class=\"row\">\n                <div class=\"col\">\n                  <div class=\"form-group mb-4\">\n                    <label class=\"toggler\" id=\"filt-yearly\">{{\n                      helper.t(\"Select reason of deal closure\")\n                    }}</label>\n                    <div\n                      class=\"btn-toolbar\"\n                      role=\"toolbar\"\n                      aria-label=\"Toolbar with button groups\"\n                    >\n                      <div class=\"btn-group me-2\" role=\"group\">\n                        <button\n                          type=\"button\"\n                          class=\"btn\"\n                          @click.prevent=\"reason = 'Ended'\"\n                          :class=\"\n                            reason == 'Ended'\n                              ? 'btn-primary'\n                              : 'btn-outline-secondary'\n                          \"\n                        >\n                          {{ helper.t(\"Deal Ended\") }}\n                        </button>\n                        <button\n                          type=\"button\"\n                          class=\"btn\"\n                          @click.prevent=\"reason = 'Canceled'\"\n                          :class=\"\n                            reason == 'Canceled'\n                              ? 'btn-primary'\n                              : 'btn-outline-secondary'\n                          \"\n                        >\n                          {{ helper.t(\"Deal Canceled\") }}\n                        </button>\n                        <button\n                          type=\"button\"\n                          class=\"btn\"\n                          @click.prevent=\"reason = 'Terminated'\"\n                          :class=\"\n                            reason == 'Terminated'\n                              ? 'btn-primary'\n                              : 'btn-outline-secondary'\n                          \"\n                        >\n                          {{ helper.t(\"Deal Terminated\") }}\n                        </button>\n                      </div>\n                    </div>\n                  </div>\n                  <div v-if=\"reason\" class=\"col-4 mb-4\">\n                    <div class=\"form-group\">\n                      <label>{{\n                        helper.t(\"Deal {0} at?\", [helper.t(reason)])\n                      }}</label>\n                      <Datepicker\n                        dir=\"ltr\"\n                        input-class=\"form-control border-radius text-start\"\n                        v-model=\"ended_at\"\n                      ></Datepicker>\n                    </div>\n                  </div>\n                </div>\n              </div>\n              <div class=\"row\">\n                <div class=\"col show-hand text-end\">\n                  <a\n                    v-if=\"reason && ended_at\"\n                    class=\"btn default-btn mt-2\"\n                    @click=\"close_deal()\"\n                  >\n                    <p>{{ helper.t(\"Save\") }}</p>\n                  </a>\n                  <a\n                    class=\"btn default-btn show-hand mt-2\"\n                    @click=\"closeModal('#end-deal-modal')\"\n                  >\n                    <p>{{ helper.t(\"No wait!\") }}</p>\n                  </a>\n                </div>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n      <!-- Modal -->\n    </template>\n  </div>\n</template>\n\n<script>\nimport * as global from \"../../../js/global\";\nimport * as helper from \"../../../js/helper\";\nimport full_loading from \"../../components/full-loading.vue\";\nimport Datepicker from \"../../../js/vuejs-datepicker.min.js\";\nimport search_filters_modal from \"../../modal/search-filters-modal.vue\";\nimport filter_tablets_component from \"../../components/filter-tablets-component.vue\";\nexport default {\n  components: {\n    full_loading: full_loading,\n    Datepicker: Datepicker,\n    search_filters_modal: search_filters_modal,\n    filter_tablets_component: filter_tablets_component,\n  },\n  name: \"deals-list\",\n  props: {},\n  data() {\n    return {\n      global,\n      helper,\n      frappe,\n      search_filters: localStorage.my_deals_search_filters\n        ? JSON.parse(localStorage.my_deals_search_filters)\n        : global.search_filters,\n      is_ready: false,\n      is_loading: false,\n      deals: [],\n      agencies: [],\n      members: [],\n      selected_deal: null,\n      reason: null,\n      ended_at: null,\n      page: 0,\n      end_of_page: false,\n      sort_by: \"creation\",\n      order: \"DESC\",\n    };\n  },\n  async mounted() {\n    if(this.search_filters.selected_agency == undefined){\n      this.search_filters.selected_agency = \"\";\n    }\n    if(this.search_filters.selected_member == undefined){\n      this.search_filters.selected_member = \"\";\n    }\n    if(frappe.user_roles.includes('Agency')){\n        await this.load_members();\n    }else if(frappe.user_roles.includes('Member')){\n        await this.load_agencies();\n    }\n    \n    if(!frappe.user_roles.includes('Member')){\n        this.search_filters.selected_agency = \"\"\n        localStorage.dashboard_search_filters = JSON.stringify(\n            this.search_filters\n        );\n    }\n    if(!frappe.user_roles.includes('Agency')){\n        this.search_filters.selected_member = \"\"\n        localStorage.dashboard_search_filters = JSON.stringify(\n            this.search_filters\n        );\n    }\n    \n    global.emitter.on(\"load-search-again\", (args) => {\n      this.load_data(true);\n    });\n    if (!helper.isPageNew()) {\n      this.check_local_storage();\n    } else {\n      this.load_data(true);\n    }\n    \n    window.addEventListener(\"scroll\", this.handleScroll);\n  },\n  unmounted() {\n    window.removeEventListener(\"scroll\", this.handleScroll);\n  },\n  methods: {\n    check_local_storage: async function () {\n      this.page = (await localStorage.my_deals_page)\n        ? localStorage.my_deals_page\n        : 0;\n      this.end_of_page = localStorage.my_deals_end_of_page == 1 ? true : false;\n      this.deals = localStorage.my_deals_records\n        ? JSON.parse(localStorage.my_deals_records)\n        : [];\n      for (let index = 0; index < this.deals.length; index++) {\n        this.deals[index][\"next\"] = helper.toMomentObj(\n          this.deals[index][\"next\"]\n        );\n        this.deals[index][\"start\"] = helper.toMomentObj(\n          this.deals[index][\"start\"]\n        );\n        this.deals[index][\"end\"] = helper.toMomentObj(\n          this.deals[index][\"end\"]\n        );\n      }\n      this.$forceUpdate();\n    },\n    reset: function () {\n      this.selected_deal = null;\n      this.reason = null;\n    },\n    load_agencies: async function(reload=true){\n        if(reload){\n            while(this.agencies.length > 0) {\n            this.agencies.pop();\n            }\n        }\n        let params = {};\n        let url = \"/api/method/maalek.api.get_registered_agencies\";\n        let res = await $.ajax({\n            url: url,\n            type: \"GET\",\n            data: params\n        });\n        for (let index = 0; index < res.message.length; index++) {\n            this.agencies.push(res.message[index]);\n        }\n        if(this.search_filters.selected_agency.length > 0){\n            if(this.agencies.find((agency)=>agency.agency == this.search_filters.selected_agency) == undefined){\n                this.search_filters.selected_agency = \"\"\n                localStorage.dashboard_search_filters = JSON.stringify(\n                    this.search_filters\n                );\n            }\n        }\n    },\n    load_members: async function(reload=true){\n        if(reload){\n            while(this.agencies.length > 0) {\n                this.agencies.pop();\n            }\n        }\n        let params = {};\n        let url = \"/api/method/maalek.api.get_agency_members\";\n        let res = await $.ajax({\n            url: url,\n            type: \"GET\",\n            data: params\n        });\n        for (let index = 0; index < res.message.length; index++) {\n            this.members.push(res.message[index]);\n        }\n        if(this.search_filters.selected_member.length > 0){\n            if(this.members.find((member)=>member.member == this.search_filters.selected_member) == undefined){\n                this.search_filters.selected_member = \"\"\n                localStorage.dashboard_search_filters = JSON.stringify(\n                    this.search_filters\n                );\n            }\n        }\n    },\n    load_data: async function (reload = false) {\n        if (this.is_loading) return;\n        if (reload) {\n            this.page = 0;\n            this.end_of_page = false;\n            while (this.deals.length > 0) {\n            this.deals.pop();\n            }\n        }\n        if (this.end_of_page) return;\n        global.emitter.emit(\"show-full-loading\");\n        this.is_loading = true;\n        \n        let params = {\n            filters: JSON.stringify(this.search_filters),\n            page: this.page,\n        };\n        let url = \"/api/method/maalek.api.get_my_deals\";\n        let res = await $.ajax({\n            url: url,\n            type: \"GET\",\n            data: params,\n        });\n\n        if (res.message.length > 0) {\n            for (let index = 0; index < res.message.length; index++) {\n            res.message[index][\"creation\"] = new Date(\n                res.message[index][\"creation\"]\n            );\n            res.message[index][\"start\"] = helper.toMomentObj(\n                res.message[index][\"start\"]\n            );\n            res.message[index][\"end\"] = helper.toMomentObj(\n                res.message[index][\"end\"]\n            );\n            res.message[index][\"next\"] = helper.toMomentObj(\n                res.message[index][\"next\"]\n            );\n            if(res.message[index][\"ended_at\"]){\n              res.message[index][\"ended_at\"] = helper.toMomentObj(\n                  res.message[index][\"ended_at\"]\n              );\n            }\n            res.message[index][\"expanded\"] = false;\n            this.deals.push(res.message[index]);\n            }\n            this.page++;\n        } else {\n            this.end_of_page = 1;\n        }\n\n        localStorage.my_deals_records = JSON.stringify(this.deals);\n        localStorage.my_deals_search_filters = JSON.stringify(\n            this.search_filters\n        );\n        localStorage.my_deals_page = this.page;\n        localStorage.my_deals_end_of_page = this.end_of_page ? 1 : 0;\n        this.is_ready = true;\n        this.is_loading = false;\n        global.emitter.emit(\"hide-full-loading\");\n    },\n    close_deal: async function () {\n      try {\n        global.emitter.emit(\"show-full-loading\");\n        let params = {\n          deal_name: this.selected_deal[\"deal_name\"],\n          reason: this.reason,\n          ended_at: this.ended_at,\n        };\n\n        let res = await $.ajax({\n          headers: { \"X-Frappe-CSRF-Token\": frappe.csrf_token },\n          url: \"/api/method/maalek.api.close_deal\",\n          type: \"POST\",\n          // data: params //for GET request\n          data: JSON.stringify(params), //for POST request\n        });\n        global.emitter.emit(\"hide-full-loading\");\n        helper.showSuccess(\"Deal \" + this.reason + \" Successfully\", () => {\n          location.reload();\n        });\n      } catch (e) {\n        console.log(e);\n        global.emitter.emit(\"hide-full-loading\");\n        var exceptions = helper.showException(e);\n      }\n    },\n    openModal: function (elementID) {\n      $(elementID).modal(\"show\");\n    },\n    closeModal: function (elementID) {\n      $(elementID).modal(\"hide\");\n    },\n    handleScroll: function () {\n      if (this.end_of_page) {\n        window.removeEventListener(\"scroll\", this.handleScroll);\n      }\n      if (this.loading || this.end_of_page) return;\n      let pagination_component = this.$refs[\"pagination_component\"];\n      if (\n        pagination_component.getBoundingClientRect().bottom < window.innerHeight\n      ) {\n        this.load_data();\n      }\n    },\n    confirm_renew_deal: function(){\n        bootbox.confirm({\n                message: `<div class=\"alert alert-info\" role=\"alert\">\n                    `+helper.t(\"Do you realy want to renew this deal?\")+`\n                </div>`,\n                backdrop: true,\n                callback: (results) => results?this.renew_deal():console.log(\"cancel\"),\n            });\n    },\n    renew_deal: async function(){\n      try {\n        global.emitter.emit(\"show-full-loading\");\n        let params = {\n                      'deal_name': this.selected_deal[\"deal_name\"],\n                  };\n        let res = await $.ajax({\n          headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },\n          url: \"/api/method/maalek.api.renew_deal\",\n          type: \"POST\",\n          // data: params //for GET request\n          data: JSON.stringify(params) //for POST request\n        });\n        global.emitter.emit(\"hide-full-loading\");\n                  helper.showSuccess(\"Deal renewed successfully.\",()=>{\n          location.reload();\n        });\n      } catch (e) {\n        global.emitter.emit(\"hide-full-loading\");\n        var exceptions = helper.showException(e);\n      }\n    },\n  },\n  computed: {},\n};\n</script>\n\n<style>\n.filter-label{\n  top: -20px;\n  position: absolute;\n}\n</style>\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../maalek/maalek/public/vue/widgets/account/deals-list.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__